import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../services/api';
import { toast } from 'sonner';

export const RegisterPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    nom: '',
    prenom: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      toast.error('Les mots de passe ne correspondent pas');
      return;
    }

    setLoading(true);

    try {
      await authService.register(formData.email, formData.password, formData.nom, formData.prenom);
      toast.success('Compte créé avec succès');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erreur lors de la création du compte');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="register-page">
      <div 
        className="hidden lg:block lg:w-1/2 bg-cover bg-center"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1755474897404-006834b70103?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjBnbGFzcyUyMGJ1aWxkaW5nJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzc1MDc2NzQ4fDA&ixlib=rb-4.1.0&q=85')" }}
      />

      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 bg-[#0B132B]">
        <div className="w-full max-w-md">
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-white mb-2" style={{ fontFamily: "'Manrope', sans-serif" }}>
              Eva
            </h1>
            <p className="text-sm text-slate-400">by ASAP Technologies</p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-2">Créer un compte</h2>
            <p className="text-sm text-slate-400">Commencez à évaluer vos candidats</p>
          </div>

          <form onSubmit={handleSubmit} data-testid="register-form">
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <label className="eva-label">Prénom</label>
                <input
                  type="text"
                  name="prenom"
                  value={formData.prenom}
                  onChange={handleChange}
                  className="eva-input"
                  required
                  data-testid="prenom-input"
                />
              </div>
              <div>
                <label className="eva-label">Nom</label>
                <input
                  type="text"
                  name="nom"
                  value={formData.nom}
                  onChange={handleChange}
                  className="eva-input"
                  required
                  data-testid="nom-input"
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="eva-label">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="eva-input"
                required
                data-testid="email-input"
              />
            </div>

            <div className="mb-4">
              <label className="eva-label">Mot de passe</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="eva-input"
                required
                data-testid="password-input"
              />
            </div>

            <div className="mb-6">
              <label className="eva-label">Confirmer le mot de passe</label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                className="eva-input"
                required
                data-testid="confirm-password-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="eva-btn-primary w-full"
              data-testid="register-submit-button"
            >
              {loading ? 'Création...' : 'Créer mon compte'}
            </button>

            <p className="text-sm text-center text-slate-400 mt-6">
              Déjà un compte ?{' '}
              <Link to="/login" className="text-white font-medium hover:underline" data-testid="login-link">
                Se connecter
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};